export default function loadSvelteComponents(components) {
  let elements = document.querySelectorAll(`[data-component]`)

  for (let element of elements) {
    let name = element.dataset["component"]
    let component = components[name]

    if (component) {
      let propsString = element.dataset["props"]
      let props = propsString ? JSON.parse(propsString) : {}

      new component.default({
        target: element,
        props: props,
      })
    } else {
      throw `Could not find component ${name}`
    }
  }
}
